<template>
    <div>
        <Item
            :img="asset('images/helpers/seeker.jpg')"
            title="Seeker"
            id="seeker"
        >
            <div class="content">
                <p class="lead">
                    I'am passionate about lifelong learning and personal growth.
                    With an academic background in business management and
                    applied psychology, I’ve spent the last 2 decades exploring
                    wisdom and life lessons from various sources and amazing
                    mentors.
                </p>
                <p>
                    I’m deeply inspired by the timeless teachings of spiritual
                    scriptures and ancient wisdom traditions from around the
                    world.
                </p>
            </div>
        </Item>
        <Item
            :img="asset('images/helpers/storyteller.jpg')"
            title="Storyteller"
            align="right"
            id="storyteller"
        >
            <div class="content">
                <p class="lead">
                    In a world of information overload, noise and hype, stories
                    can cut through the clutter, get the message across and
                    influence people. Storytelling is a unique and powerful way
                    to communicate ideas and emotions. I love to use stories to
                    inspire and educate people.I am passionate about creating
                    content that is engaging and enjoyable to consume, watch
                    WisdomShots, my popular video blog series on my
                    <a
                        :href="settings.youtube || '#'"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="font-weight-bold"
                        >YouTube Channel</a
                    >
                </p>
            </div>
        </Item>
        <Item
            :img="asset('images/helpers/facilitator.bmp')"
            title="Facilitator"
            align="left"
            id="facilitator"
        >
            <div class="content">
                <p class="lead">
                    I adore, respect and love facilitating workshops. More than
                    work, it's my deepest passion in life. Learning should be
                    fun and enjoyable, and I strive to make my workshops
                    engaging, experiential and interactive. In the last two
                    decades, I got the privilege to make a positive impact in
                    the lives of thousands of participants from different
                    nationalities through various personal growth workshops.
                </p>
                <p>
                    Watch highlights of my live workshops on
                    <a
                        href="https://www.youtube.com/watch?v=_RGv1NSy-XU&t=5s&ab_channel=SreejithKrishnan"
                        target="_blank"
                        class="font-weight-bold"
                        >YouTube</a
                    >
                </p>
            </div>
        </Item>
        <Item
            :img="asset('images/helpers/changemaker.jpg')"
            title="Change Maker"
            align="right"
            id="changemaker"
        >
            <div class="content">
                <p class="lead">
                    In my 20+ years of experience in various corporates, I had
                    the privilege to make a positive impact in the people,
                    business and culture of the organization.
                </p>
                <p>
                    I am an HR Professional with strong knowledge and experience
                    in the learning and development domain. My core area of
                    specialization is in organizational development, competency
                    mapping, facilitating development centres and performance
                    coaching.
                </p>
                <p class="mb-0 font-weight-bold">
                    My Proud Professional Associations
                </p>
                <Images :images="associationLogo" />
                <p v-if="settings.linkedin">
                    Visit my
                    <b
                        ><a :href="settings.linkedin" target="_blank"
                            >LinkedIn</a
                        >
                    </b>
                    profile to know more about my work experience.
                </p>
            </div>
        </Item>
        <Item
            :img="asset('images/helpers/lifecoach.jpg')"
            title="Life Coach"
            align="left"
            id="lifecoach"
        >
            <div class="content">
                <p class="lead">
                    There is nothing fulfilling as seeing someone grow and shine
                    with your support. Over the years I was fortunate to have
                    meaningful conversations with few folks and helped them to
                    unleash their potential and awesomeness.
                </p>
                <p class="mb-2">My Credentials:</p>
                <Images class="mt-0 mb-0" :images="myCredentials" />
            </div>
        </Item>
        <Item
            :img="asset('images/helpers/healer.jpg')"
            title="Healer"
            align="right"
            id="healer"
        >
            <div class="content">
                <p class="lead">
                    This is an area which I am really passionate about, I love
                    learning and experimenting with alternate medicine and other
                    mind-body healing techniques.
                </p>
                <p class="mb-2">My Certifications:</p>
                <Images class="mt-0 mb-0" :images="myCertifications" />
            </div>
        </Item>
    </div>
</template>
<script>
import Item from "./item.vue";
import Images from "./images";
export default {
    components: {
        Item,
        Images,
    },
    data() {
        return {
            associationLogo: [
                {
                    src: this.asset("images/associates/HGS.jpg"),
                    title: "HGS",
                },
                {
                    src: this.asset("images/associates/infosys.jpg"),
                    title: "Infosys",
                },
                {
                    src: this.asset("images/associates/RRD.jpg"),
                    title: "RRD",
                },
                {
                    src: this.asset("images/associates/Canon.jpg"),
                    title: "Canon",
                },
                {
                    src: this.asset("images/associates/sony.jpg"),
                    title: "Sony",
                },
            ],
            myCredentials: [
                {
                    src: this.asset("images/credentials/happiness_coach.png"),
                    title: "Certified Happiness Coach by Berkley Institute of Well-being, California",
                },
                {
                    src: this.asset("images/credentials/anlp.png"),
                    title: "Certified NLP Practitioner (ANLP International CC)",
                },
                {
                    src: this.asset(
                        "images/credentials/transactional_analysis.gif"
                    ),
                    title: "Certified Transactional Analysis Practitioner",
                },
                {
                    src: this.asset(
                        "images/credentials/situational_leadership.jpg"
                    ),
                    title: "Certified Situational Leadership II Facilitator",
                },
            ],
            myCertifications: [
                {
                    src: this.asset(
                        "images/certifications/emotional_freedom.gif"
                    ),
                    title: "Emotional Freedom Technique",
                },
                {
                    src: this.asset("images/certifications/reiki.png"),
                    title: "Reiki",
                },
                {
                    src: this.asset("images/certifications/pranic_healing.png"),
                    title: "Pranic Healing",
                },
                {
                    src: this.asset("images/certifications/hoopo_healing.jpg"),
                    title: "HO'OPONOPONO Healing",
                },
                {
                    src: this.asset("images/certifications/laughter_yoga.jpg"),
                    title: "Laughter Yoga",
                },
            ],
        };
    },
    computed: {
        settings() {
            return this.$page.props.config.settings;
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    p {
        letter-spacing: 0.6px;
        font-size: 1.1rem;
        opacity: 0.9;

        &.lead {
            font-weight: 500;
        }
        @media (max-width: 768px) {
            font-size: 1rem;
            letter-spacing: 0.5px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
